import React from 'react';

function ViewEventTicket({ user, closeModal }) {
  if (!user) return null;
  const BASE_URL = process.env.REACT_APP_URL;
  function formatDate(date) {
    if (!date) return 'N/A';
    return new Date(date).toLocaleDateString('en-IN', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
  }
  const imageUrl = user?.eventBanner
    ? `${BASE_URL}${user.eventBanner}`
    : null;

  return (
    <div
      className="modal fade viewbox edit-box show d-block"
      id="eventModal"
      tabIndex={-1}
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered modal-lg">

        <div className="modal-content">

          {/* =========================
              Header
          ========================== */}
          <div className="modal-header">

            <h5 className="modal-title">
              Event Details
            </h5>

            <button
              type="button"
              className="btn-close"
              onClick={closeModal}
              aria-label="Close"
            />

          </div>


          {/* =========================
              Body
          ========================== */}
          <div className="modal-body px-5">

            {/* =========================
                Event Information
            ========================== */}
            <div className="d-box mt-3 pt-1">

              <h3
                className="service-heading"
                style={{ marginBottom: '15px' }}
              >
                Event Ticket Information
              </h3>

            <ul className="d-flex list-unstyled flex-wrap justify-content-between">
    <li className="w-50 mb-3">
        <strong>Event Name: </strong>
        {user?.eventId.eventName || 'N/A'}
    </li>
    <li className="w-50 mb-3">
        <strong>Event Ticket Name: </strong>
        {user?.ticketName || 'N/A'}
    </li>

    <li className="w-50 mb-3">
        <strong>Price: </strong>
        ₹{user?.price ?? 'N/A'}
    </li>
    <li className="w-50 mb-3">
        <strong>Ticket Discount: </strong>
        ₹{user?.ticket_discount ?? 'N/A'}
    </li>
    <li className="w-50 mb-3">
        <strong>General Ticket Discount: </strong>
        ₹{user?.general_ticket_discount ?? 'N/A'}
    </li>

    <li className="w-100 mb-3">
        <strong>Description: </strong>
        {user?.description || 'N/A'}
    </li>

    <li className="w-50 mb-3">
        <strong>Status: </strong>
        {user?.status || 'N/A'}
    </li>
</ul>

            </div>


            {/* =========================
                Location
            ========================== */}
            {/* <div className="d-box mt-4 pt-1">

              <h3
                className="service-heading"
                style={{ marginBottom: '15px' }}
              >
                Location
              </h3>

              <ul className="d-flex list-unstyled flex-wrap justify-content-between">

                <li className="w-100 mb-3">
                  <strong>Address: </strong>
                  {user?.address || 'N/A'}
                </li>

                <li className="w-50 mb-3">
                  <strong>City: </strong>
                  {user?.city || 'N/A'}
                </li>

              </ul>

            </div>
            <div className="d-box mt-4 pt-1">

              <h3
                className="service-heading"
                style={{ marginBottom: '15px' }}
              >
                Terms & Conditions
              </h3>

              <ul className="d-flex list-unstyled flex-wrap">

                <li className="w-100 mb-3">
                  {user?.termsConditions || 'N/A'}
                </li>

              </ul>

            </div> */}

            {/* <div className="d-box mt-4 pt-1">

              <h3
                className="service-heading"
                style={{ marginBottom: '15px' }}
              >
                Event Image
              </h3>

              {imageUrl ? (

                <img
                  src={imageUrl}
                  alt={user?.eventName || 'Event'}
                  style={{
                    width: '150px',
                    height: '150px',
                    objectFit: 'cover',
                    borderRadius: '8px',
                    border: '1px solid #ccc'
                  }}
                />

              ) : (

                <span>N/A</span>

              )}

            </div> */}

            <div className="d-box mt-4 pt-1">

              <ul className="d-flex list-unstyled">

                <li>
                  <strong>
                    Created Date:
                  </strong>{' '}

                  {formatDate(user?.createdAt)}
                </li>

              </ul>

            </div>

          </div>

        </div>

      </div>
    </div>
  );
}

export default ViewEventTicket;